import { z } from "zod";

import { CardTemplateMessageSchema } from "./CardTemplateMessage.schema";
import { CarouselTemplateGroupSchema } from "./CarouselTemplateGroup.schema";
import { SingleItemCardTemplateGroupSchema } from "./SingleItemCardTemplateGroup.schema";
import { StandardTemplateMessageSchema } from "./StandardTemplateMessage.schema";
import { TemplateVariableSchema } from "./TemplateVariable.schema";

/**
 * Carousel template message
 */
export const CarouselTemplateMessageSchema = z.object({
  type: z.literal("carousel"),
  templateId: z.string(),
  name: z.string(),
  description: z.string(),
  variables: z.record(z.string(), TemplateVariableSchema),
  enableMultiLanguage: z.boolean().optional(),
  enableDynamicSize: z.boolean().optional(),
  templateGroup: CarouselTemplateGroupSchema.optional(),
  singleItemCardTemplateId: z.string().optional(),
  singleItemCardTemplateGroup: SingleItemCardTemplateGroupSchema.optional()
});

/**
 * WhatsApp template message - discriminated union
 */
export const WhatsAppTemplateMessageSchema = z.union([
  StandardTemplateMessageSchema,
  CardTemplateMessageSchema,
  CarouselTemplateMessageSchema
]);

export type WhatsAppTemplateMessage = z.infer<typeof WhatsAppTemplateMessageSchema>;
